import { render, staticRenderFns } from "./v-card.vue?vue&type=template&id=d715b1ca&scoped=true&"
import script from "./v-card.vue?vue&type=script&lang=js&"
export * from "./v-card.vue?vue&type=script&lang=js&"
import style0 from "./v-card.vue?vue&type=style&index=0&id=d715b1ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d715b1ca",
  null
  
)

export default component.exports